<div class="wrapper">
    <div class="page-header" style="background-image: url('./assets/img/landing2.webp');">
        <div class="filter"></div>
        <app-signin *ngIf="mode=='signin'" (goTo)="goTo($event)" (callbackFunction)="callbackSignin($event)"></app-signin>
        <app-signup *ngIf="mode=='signup'" (goTo)="goTo($event)" (callbackFunction)="callbackSignup($event)"></app-signup>
        <app-forgot-password *ngIf="mode=='reset'" (goTo)="goTo($event)" (callbackFunction)="callbackReset($event)"></app-forgot-password>
    </div>
</div>
